import { useRef } from 'react';
import './styles/base.css';
import Header from './components/Header';
import Ticker from './components/Ticker';
import Hero from './components/Hero';
import Education from './components/Education';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import {
  usePrefersReducedMotion,
  useLenis,
  useScrollSpy,
  useRevealOnScroll,
  useScrollProgress,
} from './hooks';
import { SECTION_IDS } from './data';

function App() {
  const prefersReducedMotion = usePrefersReducedMotion();
  const scrollTo = useLenis(prefersReducedMotion);
  const { activeSection, scrolled } = useScrollSpy(SECTION_IDS);
  const progressRef = useRef(null);

  useRevealOnScroll();
  useScrollProgress(progressRef);

  return (
    <div className="site">
      <div className="scroll-progress" ref={progressRef} aria-hidden="true" />
      <a href="#home" className="skip-link">
        Skip to content
      </a>

      <Header activeSection={activeSection} scrolled={scrolled} onNavigate={scrollTo} />

      <main>
        <Ticker />
        <Hero onNavigate={scrollTo} />
        <Education />
        <About />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}

export default App;
